import { i as $, B as K, e as Q, b as _, j as Z, x as T, n as A, r as W } from "../separate-component-helper-chunks/abstract-base-CzLmw6_x.js";
import { o as N } from "../separate-component-helper-chunks/map-opRCbwgx.js";
import { W as J } from "../separate-component-helper-chunks/watch-media-oRal_Bx4.js";
import { B as ee } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { a as z } from "../separate-component-helper-chunks/conditionalClasses-DMYdxrJ-.js";
import { d as te } from "../separate-component-helper-chunks/lifecycle-decorators-CUsT9aHq.js";
import { b as ae, a as V } from "../separate-component-helper-chunks/query-assigned-K46zQIzj.js";
import { B as R, f as oe } from "../separate-component-helper-chunks/table-header-DyQetOe_.js";
import { g as ne } from "../separate-component-helper-chunks/uid-HAKIZOcY.js";
import { B as L, L as C } from "../separate-component-helper-chunks/table-stub-CMTQy6H_.js";
import { B as Y, T as H } from "../separate-component-helper-chunks/table-record-DognGJeH.js";
var w = /* @__PURE__ */ ((r) => (r.MOVABLE = "movable", r.FIXED = "fixed", r.FLOATING = "floating", r))(w || {});
const re = "td", le = "table";
function ie(r) {
  var l;
  if (!r)
    return;
  const t = r.closest(re);
  if (!t)
    return;
  const a = Array.prototype.indexOf.call((l = t == null ? void 0 : t.parentNode) == null ? void 0 : l.children, t);
  if (!a)
    return;
  const e = t.closest(le);
  if (!e || !e.rows)
    return;
  let o = 0, n;
  for (n = 0; o <= a; n += 1) {
    const i = e.rows[0].cells[n];
    if (!i)
      break;
    i.dataset.colSpan ? o += parseInt(i.dataset.colSpan, 10) : o += i.colSpan;
  }
  return e.rows[0].cells[n - 1];
}
const se = "th, td", ce = 0, de = (r) => !!r && r instanceof L, be = (r) => r && r instanceof L ? r.level === C.ONE : !1, he = (r) => {
  var a, e;
  const t = r.firstElementChild;
  if (t) {
    const o = t.getAttribute("variant"), n = t.getAttribute("sort-value");
    if (o && n && (o === H.NUMERAL || o === H.DATE))
      return parseFloat(n);
    if (n)
      return n;
  }
  return (e = (a = r.textContent) == null ? void 0 : a.toLowerCase().trim()) != null ? e : "";
}, fe = (r) => {
  r && r.forEach((t) => {
    t instanceof Y ? t.sorted = !1 : t.removeAttribute("sorted");
  });
}, ue = (r, t, a, e) => {
  const o = "beacon-table-record", n = [], l = [], i = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap();
  let d = 0, s = t.firstElementChild, b = null, c = null, h = [];
  for (; s; ) {
    const m = s.querySelectorAll(se), O = s.querySelectorAll(r.getScopedTagName(o)), f = m[ce].firstElementChild;
    O && fe(O);
    const E = m[e], S = E.firstElementChild;
    if (S instanceof Y && (S.sorted = !0), be(f) || !de(f)) {
      c && h.length && (u.set(c, [...h]), c = null, h = []), n.push(s);
      const p = he(E), k = {
        index: d,
        value: p
      };
      l.push(k), d += 1;
    }
    f instanceof L && (f.level === C.ONE && (b = f), f.level === C.TWO && b && (c = f, i.set(b, f)), f.level === C.THREE && c && h.push(f)), s = s.nextElementSibling;
  }
  c && h.length && u.set(c, [...h]);
  const y = {
    levelOne: i,
    levelTwo: u
  };
  return l.sort(a.compare), {
    rowNodes: n,
    dataCells: l,
    tableStubMap: y
  };
}, ge = (r, t) => {
  const { rowNodes: a, dataCells: e, tableStubMap: o } = t;
  if (!(!e || !a.length)) {
    for (; r.firstChild; )
      r.lastChild && r.removeChild(r.lastChild);
    e.forEach((n) => {
      var l, i;
      if (n) {
        const u = a[n.index], d = (l = u.firstElementChild) == null ? void 0 : l.firstElementChild;
        if (r.appendChild(u), d instanceof L && d.level === C.ONE) {
          const s = o.levelOne.get(d), b = (i = s == null ? void 0 : s.parentElement) == null ? void 0 : i.parentElement;
          if (s && b) {
            r.appendChild(b);
            const c = o.levelTwo.get(s);
            c && c.length && c.forEach((h) => {
              var m;
              const y = (m = h.parentElement) == null ? void 0 : m.parentElement;
              y && r.appendChild(y);
            });
          }
        }
      }
    });
  }
}, pe = (r) => {
  const t = [], a = {};
  r.forEach((e) => {
    e instanceof HTMLTableCellElement && (e.headers ? a[e.headers] ? a[e.headers].push(e) : a[e.headers] = [e] : t.push(e));
  });
  for (const [e, o] of Object.entries(a)) {
    const n = t.map((l) => l.id).indexOf(e);
    t.splice(n, 1, ...o);
  }
  return t;
}, me = $`[beacon-tag-name=beacon-table]{--layer-base: 1;--layer-headers: calc(var(--layer-base) + 1);--layer-headers-sticky: calc(var(--layer-headers) + 1);background-color:transparent}[beacon-tag-name=beacon-table]:is(.beacon-on-light,.beacon-on-dark){background-color:transparent}[beacon-tag-name=beacon-table] .beacon-table{box-sizing:border-box;border:inherit;color:inherit;letter-spacing:inherit;line-height:inherit;white-space:inherit;word-spacing:inherit;font-family:inherit;font-size:inherit;font-style:inherit;font-variant:inherit;font-weight:inherit;text-align:inherit;text-indent:inherit;text-transform:inherit;border-color:var(--beacon-color-border-secondary);border-style:var(--border-style, solid);border-width:var(--beacon-border-width-small);border-spacing:0;min-inline-size:100%;overflow-wrap:break-word;position:relative;table-layout:var(--beacon-table-layout, fixed)}[beacon-tag-name=beacon-table] .beacon-table *,[beacon-tag-name=beacon-table] .beacon-table *:after,[beacon-tag-name=beacon-table] .beacon-table *:before{box-sizing:inherit}@media (width >= 640px){[beacon-tag-name=beacon-table] .beacon-table{border-radius:var(--beacon-radii-rounded)}}[beacon-tag-name=beacon-table] .beacon-table a{color:var(--beacon-color-hyperlink-default-on-light)}[beacon-tag-name=beacon-table] .beacon-table thead{inset-block-start:0;position:sticky;z-index:var(--layer-headers)}[beacon-tag-name=beacon-table] .beacon-table :is(th,td){--cell-color: var(--beacon-color-text-default-on-light);--cell-text-alignment: initial;--table-cell-padding-block: var(--beacon-component-space-padding);--table-cell-padding-inline: var(--beacon-component-space-padding);background-color:var(--beacon-color-background-default);color:var(--cell-color);font-size:var(--cell-font-size);line-height:var(--cell-line-height);padding-block:calc(var(--table-cell-padding-block) + var(--table-row-padding, 0px));padding-inline:var(--table-cell-padding-inline);position:relative;text-align:var(--cell-text-alignment);vertical-align:top}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot){--divider-border-color: var(--beacon-color-border-secondary)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) :is(th,td){--table-row-padding: var(--beacon-table-row-space-padding)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) th{--cell-font-size: var(--beacon-body-font-size-100);--cell-line-height: var(--beacon-body-font-line-height-module-100);--cell-text-alignment: start}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) td{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}[beacon-tag-name=beacon-table] .beacon-table tbody th:after{border-block-end:var(--inset-divider-border);content:"";display:block;margin-block:0;margin-inline-end:var(--inset-divider-margin-end);margin-inline-start:var(--inset-divider-margin-start);padding-block-start:var(--inset-divider-padding-block-start)}[beacon-tag-name=beacon-table] .beacon-table thead th{--cell-background: var(--beacon-table-base-header-color-background-default);--cell-color: var(--beacon-color-text-important);--divider-border-color: var(--beacon-table-base-header-color-border);--table-cell-padding-block: calc(var(--beacon-component-space-padding) + calc(.5 * var(--beacon-component-space-padding)));background-color:var(--cell-background);font-size:var(--beacon-caption-font-size-200);line-height:var(--beacon-caption-font-line-height-module-200);text-transform:uppercase}[beacon-tag-name=beacon-table] .beacon-table thead th.sorted{--cell-background: var(--beacon-table-base-header-color-background-sorted)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan]{padding-block-end:var(--beacon-unit-atomic)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan][has-dropdown]{border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table] .beacon-table thead th:not([colspan]){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table] .beacon-table thead th:first-of-type [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: var(--beacon-table-header-1st-cell-space-padding-inline-start)}[beacon-tag-name=beacon-table] .beacon-table thead th:last-of-type [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: var(--beacon-table-header-last-cell-space-padding-inline);--cell-wrapper-padding-inline-end: var(--beacon-table-header-last-cell-space-padding-inline);--text-cell-gap: var(--beacon-unit-atomic)}[beacon-tag-name=beacon-table] .beacon-table thead th:last-of-type [beacon-tag-name=beacon-table-header]:not([sortable],[action-zone]){--cell-wrapper-padding-inline-end: calc(2 * var(--beacon-table-header-nth-cell-space-padding-inline-end))}[beacon-tag-name=beacon-table] .beacon-table thead tr:not(:first-of-type) th,[beacon-tag-name=beacon-table] .beacon-table thead tr:first-of-type th:not(:last-of-type){border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:not(:last-of-type)>:is(th,td){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table] .beacon-table tfoot tr>:is(th,td){border-block-start-color:var(--divider-border-color);border-block-start-style:var(--border-style);border-block-start-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table] .beacon-table tr:is([data-beacon-selected],[data-beacon-highlighted]) th:first-of-type:before{background-color:var(--beacon-color-divider);block-size:100%;content:"";display:block;inline-size:var(--beacon-unit-subatomic);inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-highlighted] :is(th:first-of-type,td){background-color:#fafcfd}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-selected] :is(th:first-of-type,td){background-color:#ebfafc}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-highlighted] th:first-of-type{background-color:#f0f6f9}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-selected] th:first-of-type{background-color:#e1f8fb}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-header thead{z-index:var(--layer-headers-sticky)}[beacon-tag-name=beacon-table][multi-level] .beacon-table :is(tbody,tfoot) th{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-border-width-small)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{inset-inline-start:0;position:sticky}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th{z-index:var(--layer-base)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{z-index:var(--layer-headers)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column{--sticky-cell-elevation: calc(.125 * var(--beacon-unit-base)) var(--beacon-unit-subatomic) var(--beacon-unit-subatomic) rgba(var(--beacon-color-shadow-on-light), .8);--sticky-cell-elevation-stub: calc(.125 * var(--beacon-unit-base)) calc(-1 * calc(.125 * var(--beacon-unit-base))) var(--beacon-unit-subatomic) rgba(var(--beacon-color-shadow-on-light), .8)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type{filter:drop-shadow(var(--sticky-cell-elevation, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end:0;filter:drop-shadow(var(--sticky-cell-elevation-stub, none))}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub{--table-stub-floating-override-margin-inline-start: 0%}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub :is(tbody,tfoot) th{padding:0}`, ve = $`:host{--border-style: solid;word-break:initial}.table-container{block-size:var(--beacon-custom-table-container-block-size, auto);display:var(--table-container-display, block);inline-size:var(--beacon-custom-table-container-inline-size, auto);margin-inline:var(--inline-margin, 0);overflow-x:var(--beacon-custom-table-container-overflow-x, initial);scrollbar-color:var(--beacon-scrollbar-thumb-color) var(--beacon-scrollbar-track-color)}.table-container::-webkit-scrollbar{block-size:var(--beacon-scrollbar-track-size-block);inline-size:var(--beacon-scrollbar-track-size-inline)}.table-container::-webkit-scrollbar-thumb{background:var(--beacon-scrollbar-thumb-color);border-radius:var(--beacon-scrollbar-size-border-radius)}.table-container::-webkit-scrollbar-track{background:var(--beacon-scrollbar-track-color)}.table-container::-webkit-scrollbar-corner{background:var(--beacon-scrollbar-track-color)}.table-container.full-bleed{--inline-margin: calc(50% - 50vw) }.transformed-cards{--beacon-body-font-size-100: calc(.75 * var(--beacon-unit-base));--table-override-header-sort-icon-display: none;--table-override-header-wrapper-inline-size: fit-content;--table-override-stub-action-zone-right-space: 0;--table-override-stub-content-space-margin-inline-start: 0;--table-override-stub-dropdown-display: none;--table-override-header-dropdown-display: none;display:var(--transformed-cards-display, none)}.transformed-cards [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: 0;font-size:var(--beacon-caption-font-size-200);line-height:var(--beacon-caption-font-line-height-module-200)}.transformed-cards [beacon-tag-name=beacon-table-header]::part(text-cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]{font-weight:var(--beacon-font-weight-bold);line-height:var(--beacon-body-font-line-height-module-100);margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell-wrapper){margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(action-zone){margin-inline-start:var(--beacon-cell-space-padding)}.transformed-cards [beacon-tag-name=beacon-table-stub]{--stub-content-margin-inline-end: 0;--stub-content-margin-inline-start: 0}.transformed-cards [beacon-tag-name=beacon-table-stub]::part(content){padding:0}.transformed-cards [beacon-tag-name=beacon-table-header],.transformed-cards [beacon-tag-name=beacon-table-record],.transformed-cards .stub,.transformed-cards .header,.transformed-cards .record{color:var(--beacon-color-text-default-on-light);font-size:calc(.75 * var(--beacon-unit-base))}.transformed-cards .card{background-color:var(--beacon-color-background-default);border-radius:var(--beacon-radii-rounded);display:grid;gap:var(--beacon-unit-base);padding:var(--beacon-unit-base)}.transformed-cards .card:not(:last-of-type){margin-block-end:var(--beacon-unit-base)}.transformed-cards .card .stub{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default))}.transformed-cards .card-data{display:grid;font-size:calc(.75 * var(--beacon-unit-base));gap:var(--beacon-unit-base)}.transformed-cards .card-row{padding-block-end:var(--padding-block-end)}.transformed-cards .card-row .header{flex:1;line-height:var(--beacon-caption-font-line-height-module-200)}.transformed-cards .card-row .record{font-weight:var(--beacon-font-weight-bold);line-height:var(--beacon-body-font-line-height-module-100)}.transformed-cards .card-row:not(.grouped){align-items:center}.transformed-cards .card-row.grouped{--padding-block-end: var(--beacon-unit-base);display:flex;flex-direction:column}.transformed-cards .card-row:not(:last-of-type){border-block-end:var(--beacon-border-width-small) solid var(--beacon-color-border-secondary)}.transformed-cards .card-row.single{--padding-block-end: var(--beacon-unit-base)}.transformed-cards .grid{display:grid;grid-template-columns:1fr 1fr}.transformed-cards .grid .record,.transformed-cards .grid [beacon-tag-name=beacon-table-record]{justify-self:end}.transformed-cards .header-children :is(.header,[beacon-tag-name=beacon-table-header]){text-indent:var(--beacon-unit-base)}:host([is-scrolling-block]) .table-container{block-size:calc(var(--js-component-size-block) - var(--beacon-table-space-padding) * 4)}:host([use-cards]){--table-container-display: none;--transformed-cards-display: block}:host([use-cards]) a{color:var(--beacon-color-hyperlink-default-on-light-color-text)}@media (width >= 640px){.table-container.full-bleed{--inline-margin: 0}:host([use-cards]){--table-container-display: block;--transformed-cards-display: none}}`;
var ye = Object.defineProperty, Te = Object.getOwnPropertyDescriptor, v = (r, t, a, e) => {
  for (var o = e > 1 ? void 0 : e ? Te(t, a) : t, n = r.length - 1, l; n >= 0; n--)
    (l = r[n]) && (o = (e ? l(t, a, o) : l(o)) || o);
  return e && o && ye(t, a, o), o;
};
const P = {
  childList: !0,
  characterData: !0,
  subtree: !0
}, U = "beacon-table-header", Ee = "beacon-table-stub", B = "beacon-table-record", F = "table", Se = "thead", q = "tbody", Ce = "tr", ke = "thead th", we = "tbody tr th:first-of-type", Ae = "td", G = "beacon-table", Le = "thead th", Oe = "--table-stub-floating-override-inset-inline-start", _e = "px", Ne = 0.8, Re = { rootMargin: "3000px" }, x = class x extends ee(K, J()) {
  constructor() {
    super(...arguments), this.beaconTagName = G, this.deferOptions = Re, this.CLASS_NAMES = {
      STICKY_STUB: "has-sticky-stub-column",
      STICKY_HEADER: "has-sticky-header",
      LIGHT_DOM_TABLE: "beacon-table",
      FLOATING_STUB: "floating-stub"
    }, this.SLOTTED_TABLE_INDEX = 0, this.variant = w.MOVABLE, this.useCards = !1, this.hasMultiLevel = !1, this.mobileFullBleed = !1, this.scrollPositionBlock = 0, this.scrollPositionInline = 0, this.mutationObserver = new MutationObserver((t) => {
      const a = [F, Se, q, Ce];
      t.forEach((e) => {
        const { target: o, type: n } = e;
        n === "childList" && (o.assignedSlot || a.includes(o.nodeName.toLowerCase())) && this.renderTransformedCards();
      });
    }), this.handleBreakpointChanges = ({ matches: t }) => {
      t || (this.renderTransformedCards(), this.mutationObserver.observe(this.slottedTable, P));
    }, this.sortRows = (t) => {
      var s, b;
      this.mutationObserver.disconnect();
      let a;
      const e = t.target instanceof R ? t.target : null;
      if (!e)
        return;
      const o = e.parentElement, n = (s = e.closest(F)) == null ? void 0 : s.querySelector(q), l = o instanceof HTMLTableCellElement;
      if (!o || !n || !l)
        return;
      const i = pe(this.headers);
      if (e.dropdown && e.selectedValue) {
        const c = e.selectedValue;
        a = i.map((h) => h.id).indexOf(c);
      } else
        a = i.indexOf(o);
      const u = ue(this, n, e, a);
      ge(n, u);
      const d = t.target instanceof R ? (b = t == null ? void 0 : t.detail) == null ? void 0 : b.id : null;
      this.updateSortAttributes(d), this.mediumBreakpointWatcher.addEventListener("change", this.handleBreakpointChanges);
    };
  }
  static get styles() {
    return [super.styles, ve];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, me];
  }
  /**
   * Gets a NodeList of all `<th>` elements in the `<thead>`. BeaconTableHeaders generally reside within these `<th>` elements.
   */
  get headers() {
    return this.tables[this.SLOTTED_TABLE_INDEX].querySelectorAll(ke);
  }
  /** Stubs inside the table. */
  get stubs() {
    return this.slottedTable.querySelectorAll(we);
  }
  /** Records inside the table. */
  get records() {
    return this.slottedTable.querySelectorAll(Ae);
  }
  /**
   * Use this to receive a reference to the slotted `<table>` element
   *
   * @returns The first element in the component's queryAssignedElements, typed as a `<table>`
   */
  get slottedTable() {
    return this.tables[this.SLOTTED_TABLE_INDEX];
  }
  /**
   * sets hasMultiLevel property to true
   */
  triggerMultiLevel() {
    this.hasMultiLevel = !0;
  }
  /**
   * Receive scroll events on the component and set scroll position states
   *
   * @see constructor
   *
   * @param event Scroll event
   */
  captureScrollPosition(t) {
    var n, l;
    const { target: a } = t, { scrollLeft: e, scrollTop: o } = a;
    if (this.scrollPositionInline = e, this.scrollPositionBlock = o, this.variant === w.FLOATING) {
      const i = (l = (n = this.slottedTable) == null ? void 0 : n.querySelector(Le)) == null ? void 0 : l.clientWidth, u = Math.abs(this.scrollPositionInline) + _e;
      this.style.setProperty(Oe, u), i && i * Ne < this.scrollPositionInline ? this.slottedTable.classList.add(this.CLASS_NAMES.FLOATING_STUB) : this.slottedTable.classList.remove(this.CLASS_NAMES.FLOATING_STUB);
    }
    this.variant === w.FIXED && z(this.scrollPositionInline, this.slottedTable, this.CLASS_NAMES.STICKY_STUB), z(this.scrollPositionBlock, this.slottedTable, this.CLASS_NAMES.STICKY_HEADER);
  }
  /**
   * - Adds a class to the slotted table for scoped stying
   * - Appends a light DOM style tag containing scoped styles
   * - Sets the number of columns in state
   * - Runs scrolling state methods
   */
  async firstUpdated() {
    this.slottedTable && this.slottedTable.classList && (this.slottedTable.classList.add(this.CLASS_NAMES.LIGHT_DOM_TABLE), await this.updateComplete, this.useCards && (this.isMobile ? (this.renderTransformedCards(), this.mutationObserver.observe(this.slottedTable, P)) : this.mediumBreakpointWatcher.addEventListener("change", this.handleBreakpointChanges))), super.firstUpdated();
  }
  /** Emit a custom event when the cards render. */
  emitRenderTableCards(t) {
    Q(this, _.RENDER_TABLE_CARDS);
  }
  /**
   * Creates content for the cards from the stub, header, or record parent elements.
   * @param start Element to use as the reference node
   * @param type The type of component the final result is, such as 'stub' or 'header' or 'record'
   * @returns A new element made from the children of the starting element
   */
  generateCardContent(t, a) {
    const e = document.createElement("div"), o = Array.from(t.childNodes).map((i) => i.cloneNode(!0));
    o && e.append(...o);
    const n = ne(), l = "uuid";
    return t.setAttribute(l, n), e.setAttribute(l, n), e.classList.add(a), e;
  }
  /**
   * Clones a Beacon Table Cell and changes its state.
   * @param component Beacon Table component to be cloned
   * @returns Clone of the node with its state changed
   */
  cloneComponent(t) {
    const a = t.cloneNode(!0);
    return a.isOriginal = !1, a;
  }
  /* eslint-disable consistent-return */
  /** For mobile card view, iterate over all child components and clone them into cards. */
  async renderTransformedCards() {
    this.mediumBreakpointWatcher.removeEventListener("change", this.handleBreakpointChanges), await this.updateComplete;
    const t = "stub", a = "header", e = "record", o = N(this.stubs, (n) => {
      if (!this.records)
        return;
      const l = Array.from(this.records).filter((d) => {
        var s;
        return (s = n.parentNode) == null ? void 0 : s.contains(d);
      }), i = n.querySelector(this.getScopedTagName(Ee)), u = i ? this.cloneComponent(i) : this.generateCardContent(n, t);
      return T`
        <div class="card">
          ${u}
          <div class="card-data">
            ${N(this.headers, (d, s) => {
        if (!this.records || s === 0)
          return;
        let b = T``, c = "single grid", h;
        const y = Array.from(this.records).filter((p) => ie(p) === d);
        if (!y)
          return b;
        const m = y.find((p) => l.includes(p));
        if (!m)
          return b;
        const f = oe(d, !1, !1, ["th"]), E = d.querySelector(this.getScopedTagName(U)), S = E ? this.cloneComponent(E) : this.generateCardContent(d, a);
        if (f && f.length > 0)
          c = "grouped", b = T`${S}
                ${N(f, (p, k) => {
            const X = l.indexOf(m) + k, D = l[X], I = p.querySelector(this.getScopedTagName(U)), j = I ? this.cloneComponent(I) : this.generateCardContent(p, a), M = D.querySelector(this.getScopedTagName(B));
            return h = M ? this.cloneComponent(M) : this.generateCardContent(D, e), T` <div class="header-children grid">${j} ${h}</div> `;
          })} `;
        else {
          const p = m.querySelector(this.getScopedTagName(B));
          h = p ? this.cloneComponent(p) : this.generateCardContent(m, e), b = T` ${S} ${h} `;
        }
        return T` <div class="card-row ${c}">${b}</div> `;
      })}
          </div>
        </div>
      `;
    });
    Z(o, this.transformedCardsContainer), this.emitRenderTableCards(), this.triggerRecordActionZoneStatus();
  }
  /* eslint-enable consistent-return */
  /**
   * Manually calls `setActionZoneStatus` on each BeaconTableRecord component in the cards to make sure the slot area is visible or hidden as needed.
   */
  async triggerRecordActionZoneStatus() {
    this.transformedCardsContainer.querySelectorAll(
      this.getScopedTagName(B)
    ).forEach(async (a) => {
      await a.updateComplete, a.setActionZoneStatus();
    });
  }
  /**
   * tabindex is added to `div.table-container` to pass a11y test of "Scrollable region must have keyboard access"
   */
  render() {
    return T`
      <div class="transformed-cards"></div>
      <div class="table-container ${this.mobileFullBleed ? "full-bleed" : "contained"}" tabindex="0" @scroll=${this.captureScrollPosition}>
        <slot></slot>
      </div>
    `;
  }
  willUpdate(t) {
    t.has("useCards") && (this.isMobile ? this.renderTransformedCards() : this.mediumBreakpointWatcher.addEventListener("change", this.handleBreakpointChanges));
  }
  /**
   * This updates sort-inactive attributes on all BeaconTableHeaders except the one that triggered the sort event.
   * @param targetId Id of BeaconTableHeader that triggered the sort event
   */
  updateSortAttributes(t) {
    const a = this.querySelectorAll('[beacon-tag-name="beacon-table-header"]');
    a && Array.from(a).forEach((e) => {
      var o;
      e instanceof R && ((o = e == null ? void 0 : e.parentElement) == null ? void 0 : o.id) !== t && e.resetSortedAttr(e);
    });
  }
  /**
   * Not using @prerender here because table needs to be able to sort
   * in defer-until=visible context.
   */
  connectedCallback() {
    setTimeout(() => this.addEventListener(_.SORT, this.sortRows), 100), super.connectedCallback();
  }
  tearDownTable() {
    setTimeout(() => this.removeEventListener(_.SORT, this.sortRows), 100);
  }
};
x.tagName = G;
let g = x;
v([
  A({ reflect: !0 })
], g.prototype, "variant", 2);
v([
  A({ type: Boolean, attribute: "use-cards" })
], g.prototype, "useCards", 2);
v([
  A({ attribute: "multi-level", type: Boolean, reflect: !0 })
], g.prototype, "hasMultiLevel", 2);
v([
  A({ attribute: "mobile-full-bleed", type: Boolean })
], g.prototype, "mobileFullBleed", 2);
v([
  W()
], g.prototype, "scrollPositionBlock", 2);
v([
  W()
], g.prototype, "scrollPositionInline", 2);
v([
  ae({ flatten: !0, selector: "table" })
], g.prototype, "tables", 2);
v([
  V(".table-container")
], g.prototype, "tableContainer", 2);
v([
  V(".transformed-cards")
], g.prototype, "transformedCardsContainer", 2);
v([
  te
], g.prototype, "tearDownTable", 1);
export {
  g as BeaconTable
};
